import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";
import { Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import moment from "moment";
import { DESIGNS, PopupDesign } from "./PopupDesigns";
import { IMPLEMENTED_TRIGGERS, REWARD_TYPES_INSTANT, REWARD_TYPES_ON_PURCHASE } from "./triggers";

const CreatePopupOffer = (props) => {
  const { onClose, editData, open, ...other } = props;
  const isEdit = !!editData?.id;
  const [isLoading, setIsLoading] = useState(false);

  const [name, setName] = useState("");
  const [template, setTemplate] = useState("hero");
  const [triggerEvent, setTriggerEvent] = useState("");
  const [priority, setPriority] = useState(1);
  const [active, setActive] = useState(true);
  const [activeFrom, setActiveFrom] = useState("");
  const [activeTo, setActiveTo] = useState("");
  const [maxPerDay, setMaxPerDay] = useState(1);
  const [ctaText, setCtaText] = useState("");
  const [ctaLink, setCtaLink] = useState("");
  // optional middle content — the design component renders these, only the boxes it declares in `fields`
  const [sub, setSub] = useState("");
  const [valueBig, setValueBig] = useState("");
  const [valueLabel, setValueLabel] = useState("");
  const [items, setItems] = useState("");
  const [timer, setTimer] = useState(false);
  const [finePrint, setFinePrint] = useState("");
  const [rewardMode, setRewardMode] = useState("none");
  const [rewardType, setRewardType] = useState("");
  const [rewardBonus, setRewardBonus] = useState("");
  const [rewardRafPercent, setRewardRafPercent] = useState("");
  const [gameSearch, setGameSearch] = useState("");
  const [gameOptions, setGameOptions] = useState([]);
  const [rewardGame, setRewardGame] = useState(null);
  const [rewardSpinCount, setRewardSpinCount] = useState("");
  const [rewardSpinValue, setRewardSpinValue] = useState("");
  const [packageId, setPackageId] = useState("");
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    getAllData(endPoints.api.GET_ALL_PACKAGE)
      .then((res) => {
        if (res?.status === "success") setPackages(res?.data || []);
      })
      .catch(() => {});
  }, []);

  // search free-spin games the same way the existing Free Spins section does
  useEffect(() => {
    if (!gameSearch || gameSearch.length < 2) { setGameOptions([]); return; }
    const t = setTimeout(async () => {
      try {
        const res = await getAllData(`${endPoints.api.SEARCH_FREESPIN_GAMES}/${encodeURIComponent(gameSearch)}`);
        if (res?.status === "success") setGameOptions(res?.data || []);
      } catch (e) { console.error(e); }
    }, 500);
    return () => clearTimeout(t);
  }, [gameSearch]);

  useEffect(() => {
    if (!open) return;
    let content = {};
    try {
      content = editData?.content ? JSON.parse(editData.content) : {};
    } catch (e) {
      content = {};
    }
    setName(editData?.name ?? "");
    setTemplate(editData?.template ?? "hero");
    setTriggerEvent(editData?.triggerEvent ?? "");
    setPriority(editData?.priority ?? 1);
    setActive(editData?.active ?? true);
    setActiveFrom(
      editData?.activeFrom
        ? moment(editData.activeFrom).format("YYYY-MM-DDTHH:mm")
        : moment().format("YYYY-MM-DDTHH:mm")
    );
    setActiveTo(editData?.activeTo ? moment(editData.activeTo).format("YYYY-MM-DDTHH:mm") : "");
    setMaxPerDay(editData?.maxPerDay ?? editData?.max_per_day ?? 1);
    setCtaText(editData?.ctaText ?? "");
    setCtaLink(editData?.ctaLink ?? "");
    setSub(content?.sub ?? "");
    setValueBig(content?.value ?? "");
    setValueLabel(content?.valueLabel ?? "");
    setItems((content?.items || []).join("\n"));
    setTimer(content?.timer ?? false);
    setFinePrint(content?.finePrint ?? "");
    setRewardMode(editData?.rewardMode ?? "none");
    setRewardType(editData?.rewardType === "WOF_RESET" ? "WOF" : editData?.rewardType ?? "");
    setRewardBonus(editData?.rewardBonus ?? "");
    setRewardRafPercent(editData?.rewardRafPercent ?? "");
    setRewardSpinCount(editData?.rewardSpinCount ?? "");
    setRewardSpinValue(editData?.rewardSpinValue ?? "");
    setRewardGame(editData?.rewardGameId ? { game_id: editData.rewardGameId, game_name: editData.rewardGameName } : null);
    setGameSearch(editData?.rewardGameName ?? "");
    setPackageId(editData?.packageId ?? "");
  }, [editData, open]);

  // instant rewards can only ever be claimed once — lock the lifetime cap to 1
  useEffect(() => {
    if (rewardMode === "instant") setMaxPerDay(1);
  }, [rewardMode]);

  const design = DESIGNS.find((d) => d.key === template) || DESIGNS[0];
  const designFields = design.fields || [];
  const rewardTypeOptions = rewardMode === "on_purchase" ? REWARD_TYPES_ON_PURCHASE : REWARD_TYPES_INSTANT;
  // BOOSTER always targets a specific coin package flagged isBoost — same source list as
  // the generic package pickers, just filtered down.
  const boosterPackages = packages.filter((p) => p?.isBoost);

  const validate = () => {
    if (!name || !triggerEvent || !template) {
      ErrorToast("Name, trigger and design are required");
      return false;
    }
    if (!ctaText) {
      ErrorToast("Enter the button text");
      return false;
    }
    const pr = Number(priority);
    if (isNaN(pr) || pr < 1) {
      ErrorToast("Priority must be 1 or more (1 = highest)");
      return false;
    }
    if (rewardMode === "instant" && Number(maxPerDay) > 1) {
      ErrorToast("Direct reward offers can only be shown/claimed once — Max shows must be 1");
      return false;
    }
    if (rewardMode !== "none") {
      if (!rewardType) {
        ErrorToast("Select a reward type");
        return false;
      }
      if (rewardType === "BONUS" && !(Number(rewardBonus) > 0)) {
        ErrorToast("Bonus amount must be greater than 0");
        return false;
      }
      if (rewardType === "RAF_BOOST" && !(Number(rewardRafPercent) > 0)) {
        ErrorToast("RAF boost percent must be greater than 0");
        return false;
      }
      if (rewardType === "BOOSTER" && !packageId) {
        ErrorToast("Select the booster package");
        return false;
      }
      if (rewardType === "FREE_SPIN" && (!rewardGame?.game_id || !(Number(rewardSpinCount) > 0) || !(Number(rewardSpinValue) > 0))) {
        ErrorToast("Free spin reward needs game, spin count and spin value");
        return false;
      }
      if (rewardMode === "on_purchase" && !packageId) {
        ErrorToast("Purchase-required offers need a package");
        return false;
      }
    }
    return true;
  };

  const handleOk = () => {
    if (!validate()) return;
    const content = { headline: name };
    if (designFields.includes("sub") && sub) content.sub = sub;
    if (designFields.includes("value") && valueBig) content.value = valueBig;
    if (designFields.includes("valueLabel") && valueLabel) content.valueLabel = valueLabel;
    if (designFields.includes("items") && items) content.items = items.split("\n").map((s) => s.trim()).filter(Boolean);
    if (designFields.includes("timer") && timer) content.timer = true;
    if (designFields.includes("finePrint") && finePrint) content.finePrint = finePrint;

    // package picked -> point the CTA at the same buy-coins deep link the email-package
    // flow and popup WOF PACKAGE segments already use, so the button actually opens that pack.
    const buyPkg = packageId ? packages.find((p) => String(p.id) === String(packageId)) : null;

    const payload = {
      name,
      template,
      triggerEvent,
      priority: Number(priority),
      active,
      activeFrom: activeFrom ? moment(activeFrom).format("YYYY-MM-DDTHH:mm:ss") : null,
      activeTo: activeTo ? moment(activeTo).format("YYYY-MM-DDTHH:mm:ss") : null,
      maxPerDay: Number(maxPerDay),
      ctaText,
      ctaLink: buyPkg?.packageId ? `/buy-coins?packageId=${buyPkg.packageId}&segment=N1` : ctaLink,
      content: JSON.stringify(content),
      rewardMode,
      rewardType: rewardMode === "none" ? null : rewardType,
      rewardBonus: rewardType === "BONUS" ? Number(rewardBonus) : null,
      rewardRafPercent: rewardType === "RAF_BOOST" ? Number(rewardRafPercent) || 0 : null,
      rewardSpinCount: rewardType === "FREE_SPIN" ? Number(rewardSpinCount) : null,
      rewardSpinValue: rewardType === "FREE_SPIN" ? Number(rewardSpinValue) : null,
      rewardGameId: rewardType === "FREE_SPIN" ? rewardGame?.game_id || null : null,
      rewardGameName: rewardType === "FREE_SPIN" ? rewardGame?.game_name || null : null,
      packageId: packageId ? Number(packageId) : null,
    };
    if (isEdit) payload.id = editData.id;
    const url = isEdit ? endPoints.api.POPUP_OFFER_UPDATE : endPoints.api.POPUP_OFFER_ADD;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.status === "success") {
          SuccesToast(response?.data?.message);
          onClose();
        } else {
          ErrorToast(response?.data?.message || "Save failed");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast("Save failed");
      });
  };

  const fc = { width: "100%", marginTop: "18px" };

  return (
    <Dialog sx={{ "& .MuiDialog-paper": { width: "90%" } }} maxWidth="md" open={open} {...other}>
      <DialogTitle>{isEdit ? "Edit" : "Create"} Pop-up Offer</DialogTitle>
      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        {/* ----- pick a design (preview-driven) ----- */}
        <Form.Label style={{ fontWeight: "bold", marginTop: 4 }}>
          {isEdit ? "Design (locked — can't change on edit)" : "Choose a design *"}
        </Form.Label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
          {(isEdit ? DESIGNS.filter((d) => d.key === template) : DESIGNS).map((d) => {
            const on = template === d.key;
            return (
              <div
                key={d.key}
                onClick={isEdit ? undefined : () => setTemplate(d.key)}
                style={{
                  cursor: isEdit ? "default" : "pointer",
                  width: 150,
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: on ? "2px solid #5B21B6" : "1px solid #ddd",
                  background: on ? "#f3f0fb" : "#fff",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 13 }}>{d.label}</div>
                <div style={{ fontSize: 11, color: "#777" }}>{d.desc}</div>
              </div>
            );
          })}
        </div>

        {/* ----- live preview of the selected design ----- */}
        <div
          style={{
            background: "radial-gradient(120% 90% at 50% 0%,#2a2350,#140f24)",
            borderRadius: 14,
            padding: 24,
            display: "grid",
            placeItems: "center",
            minHeight: 240,
          }}
        >
          <PopupDesign
            design={template}
            ctaText={ctaText || "Button"}
            endsAt={activeTo}
            content={{
              headline: name || "Your offer",
              sub,
              value: valueBig,
              valueLabel,
              items: items.split("\n").map((s) => s.trim()).filter(Boolean),
              timer,
              finePrint,
            }}
          />
        </div>

        <FormControl style={fc}>
          <TextField label="Offer name * (shown as the headline)" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <TextField label="Button text *" variant="outlined" value={ctaText} onChange={(e) => setCtaText(e.target.value)} />
        </FormControl>

        <hr />
        <Form.Label style={{ fontWeight: "bold" }}>Content (optional — fills the design)</Form.Label>
        {designFields.includes("sub") && (
          <FormControl style={fc}>
            <TextField label="Sub-text" variant="outlined" value={sub} onChange={(e) => setSub(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("value") && (
          <FormControl style={fc}>
            <TextField label='Value headline (e.g. "+150%")' variant="outlined" value={valueBig} onChange={(e) => setValueBig(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("valueLabel") && (
          <FormControl style={fc}>
            <TextField label='Value label (e.g. "bonus on pack 1")' variant="outlined" value={valueLabel} onChange={(e) => setValueLabel(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("items") && (
          <FormControl style={fc}>
            <TextField label="Items (one per line)" multiline minRows={2} variant="outlined" value={items} onChange={(e) => setItems(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("finePrint") && (
          <FormControl style={fc}>
            <TextField label="Fine print" variant="outlined" value={finePrint} onChange={(e) => setFinePrint(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("timer") && (
          <FormControlLabel
            style={{ marginTop: 8, display: "block" }}
            control={<Switch checked={!!timer} onChange={() => setTimer(!timer)} />}
            label="Show countdown timer"
          />
        )}

        <hr />
        <Form.Label style={{ fontWeight: "bold" }}>Reward (optional)</Form.Label>
        <FormControl style={fc}>
          <TextField
            select
            label="Reward mode"
            value={rewardMode}
            onChange={(e) => {
              setRewardMode(e.target.value);
              setRewardType("");
            }}
          >
            <MenuItem value="none">No reward</MenuItem>
            <MenuItem value="instant">Reward only — button credits instantly</MenuItem>
            <MenuItem value="on_purchase">Reward after package buy — credits when the package is purchased</MenuItem>
          </TextField>
        </FormControl>
        {rewardMode === "none" && (
          <FormControl style={fc}>
            <TextField select label="Package to buy (optional — no reward, user just buys it)" value={packageId} onChange={(e) => setPackageId(e.target.value)}>
              <MenuItem value="">None</MenuItem>
              {packages.map((p) => (
                <MenuItem key={p.id} value={String(p.id)}>${p.purchase_price} — {p.package_name || p.packagename || `#${p.id}`}</MenuItem>
              ))}
            </TextField>
          </FormControl>
        )}
        {rewardMode !== "none" && (
          <>
            <FormControl style={fc}>
              <TextField select label="Reward type" value={rewardType} onChange={(e) => setRewardType(e.target.value)}>
                <MenuItem value="">Select type</MenuItem>
                {rewardTypeOptions.map((t) => (
                  <MenuItem key={t} value={t}>{t}</MenuItem>
                ))}
              </TextField>
            </FormControl>
            {rewardType === "BONUS" && (
              <FormControl style={fc}>
                <TextField label="Bonus amount ($)" type="number" inputProps={{ min: 0, step: "0.1" }} variant="outlined" value={rewardBonus} onChange={(e) => setRewardBonus(e.target.value)} />
              </FormControl>
            )}
            {rewardType === "RAF_BOOST" && (
              <FormControl style={fc}>
                <TextField label="Boost percent (%)" type="number" inputProps={{ min: 1, max: 500 }} variant="outlined" value={rewardRafPercent} onChange={(e) => setRewardRafPercent(e.target.value)} />
              </FormControl>
            )}
            {rewardType === "BOOSTER" && (
              <FormControl style={fc}>
                <TextField select label="Booster package *" value={packageId} onChange={(e) => setPackageId(e.target.value)}>
                  {boosterPackages.length === 0 && <MenuItem value="" disabled>No packages flagged as booster</MenuItem>}
                  {boosterPackages.map((p) => (
                    <MenuItem key={p.id} value={String(p.id)}>
                      ${p.purchase_price} — {p.package_name || p.packagename || `#${p.id}`}{p.boostValue ? ` (+${p.boostValue}% boost)` : ""}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            )}
            {rewardType === "FREE_SPIN" && (
              <>
                <FormControl style={fc}>
                  <Autocomplete
                    options={gameOptions}
                    getOptionLabel={(g) => g?.game_name || ""}
                    isOptionEqualToValue={(o, v) => o?.game_id === v?.game_id}
                    filterOptions={(x) => x}
                    value={rewardGame}
                    inputValue={gameSearch}
                    onInputChange={(e, val, reason) => {
                      setGameSearch(val);
                      if (reason === "input") setRewardGame(null);
                    }}
                    onChange={(e, g) => setRewardGame(g)}
                    renderInput={(params) => <TextField {...params} label="Game (type 2+ letters to search)" variant="outlined" />}
                  />
                </FormControl>
                <FormControl style={fc}>
                  <TextField label="Spin count" type="number" inputProps={{ min: 1 }} variant="outlined" value={rewardSpinCount} onChange={(e) => setRewardSpinCount(e.target.value)} />
                </FormControl>
                <FormControl style={fc}>
                  <TextField label="Spin value (cents)" type="number" inputProps={{ min: 1 }} variant="outlined" value={rewardSpinValue} onChange={(e) => setRewardSpinValue(e.target.value)} />
                </FormControl>
              </>
            )}
            {rewardType === "WOF" && (
              <p style={{ marginTop: 12 }}>
                Wheel segments and probabilities are configured on the Wheel of Fortune screen (Popup Wheel tab).
              </p>
            )}
            {rewardMode === "on_purchase" && rewardType !== "BOOSTER" && (
              <FormControl style={fc}>
                <TextField select label="Package that unlocks the reward *" value={packageId} onChange={(e) => setPackageId(e.target.value)}>
                  {packages.map((p) => (
                    <MenuItem key={p.id} value={String(p.id)}>${p.purchase_price} — {p.package_name || p.packagename || `#${p.id}`}</MenuItem>
                  ))}
                </TextField>
              </FormControl>
            )}
          </>
        )}

        <hr />
        <Form.Label style={{ fontWeight: "bold" }}>Targeting & rules</Form.Label>
        <FormControl style={fc}>
          <TextField select label="Trigger *" value={triggerEvent} onChange={(e) => setTriggerEvent(e.target.value)}>
            {IMPLEMENTED_TRIGGERS.map((t) => (
              <MenuItem key={t.value} value={t.value}>{t.value}</MenuItem>
            ))}
          </TextField>
        </FormControl>
        <FormControl style={fc}>
          <TextField label="Priority (lower wins — 1 = first)" type="number" inputProps={{ min: 1 }} variant="outlined" value={priority} onChange={(e) => setPriority(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <label>Active from (auto — starts now; set later to schedule)</label>
          <TextField type="datetime-local" variant="outlined" value={activeFrom} onChange={(e) => setActiveFrom(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <label>Active to (blank = runs until turned off)</label>
          <TextField type="datetime-local" variant="outlined" value={activeTo} onChange={(e) => setActiveTo(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <TextField
            label="Max shows (per user — total, ever)"
            type="number"
            inputProps={{ min: 1, max: rewardMode === "instant" ? 1 : undefined }}
            disabled={rewardMode === "instant"}
            helperText={rewardMode === "instant" ? "Locked to 1 — a direct reward can only ever be claimed once" : ""}
            variant="outlined"
            value={maxPerDay}
            onChange={(e) => setMaxPerDay(e.target.value)}
          />
        </FormControl>
        <FormControlLabel style={{ marginTop: 8, display: "block" }} control={<Switch checked={!!active} onChange={() => setActive(!active)} />} label="Active" />
      </DialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleOk}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePopupOffer;
